import { render, staticRenderFns } from "./ContentMockup.vue?vue&type=template&id=474cf797&"
import script from "./ContentMockup.vue?vue&type=script&lang=js&"
export * from "./ContentMockup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports